module.exports = __webpack_public_path__ + "img/open-menu.773b0114.svg";